
































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import VendorListingEditor from '@ui/Creative/VendorListingEditor'
import CreativeEditor from '@ui/Creative/CreativeEditor'
import UpdateLineItemDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateLineItemDiscountTriggerModal'
import UpdateAddonDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateAddonDiscountTriggerModal'

import UpdateOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPriceTriggerModal'
import UpdateOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPayoutTriggerModal'
import UpdateAddonOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPriceTriggerModal'
import UpdateAddonOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPayoutTriggerModal'
import AddCreditToPurchaseOrderLineItemTriggerModal from '@triggers/PurchaseOrder/AddCreditToPurchaseOrderLineItemTriggerModal'

settings =
  name: "PurchaseOrderLineItemEditPage"
  components: {
    Modal,
    VendorListingEditor,
    CreativeEditor,
    UpdateLineItemDiscountTriggerModal,
    UpdateAddonDiscountTriggerModal,
    UpdateOriginalPriceTriggerModal,
    UpdateOriginalPayoutTriggerModal,
    UpdateAddonOriginalPriceTriggerModal,
    UpdateAddonOriginalPayoutTriggerModal,
    AddCreditToPurchaseOrderLineItemTriggerModal,
  }

  resources:
    purchase_order:
      resourceName: 'purchase_order'
      slug: 'purchase_orders/:purchaseOrderId'
      fetch: false

    line_item:
      resourceName: 'purchase_order_line_item'
      slug: 'purchase_orders/:purchaseOrderId/purchase_order_line_items/:purchaseOrderItemId'

    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'

    activation_plans:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans'
      fetch: false

  vue:
    data: ->
      creativeEditorModal:
        show: true

    computed:
      purchaseOrderId: -> @$route.params.purchaseOrderId
      purchaseOrderItemId: -> @$route.params.purchaseOrderItemId
      lineItem: -> @line_item
      listingLineItems: -> [@lineItem]

      campaignId: -> @purchase_order?.campaign_id
      audienceListingId: -> @ctxAudienceListing(@lineItem).id
      vendorListingId: -> @ctxVendorListing(@lineItem).id
      listingId: -> @audienceListingId or @vendorListingId
      segment: -> @lineItem?.space_name?.split(':')[1]
      activationPlanId: -> "#{@campaignId}:#{@listingId}:#{@segment}"

      optionsForCreativeEditor: ->
        segment: @segment
        activationPlanId: @activationPlanId

      actionsForCreativeEditor: ->
        {
          @removeLineItem,
          @updateLineItemQuantity,
          @updateActivationDate,
          @addAddonLineItem,
          @removeAddon,
          @hiUpdateAddonQuantityFn,
          @promptUpdateLineItemDiscount,
          @promptUpdateAddonDiscount,
          @updateOriginalPriceTrigger,
          @updateOriginalPayoutTrigger,
          @updateAddonOriginalPriceTrigger,
          @updateAddonOriginalPayoutTrigger,
          @setVariable,
          @updateActivationDatesPlan,
          @updateMaxPalletCount,
          @selectShippingPlan,
          @addCreditToLineItem,
        }

    methods:
      hiSaveVendorListing: (payload) ->
        @triggerResource 'line_item', 'update_vendor_listing_line_item', payload
      onLineItemUpdateVendorListingLineItem: ->
        @navToPurchaseOrderShowPage()

      fetchActivationPlans: ->
        @fetch 'activation_plans', {
          purchase_order_id: @purchase_order.id
          audience_listing_ids: [@audienceListingId] if @audienceListingId
          vendor_listing_ids: [@vendorListingId] if @vendorListingId
        }

      onLoadItemCompleted: (resourceKey) ->
        @fetch 'campaign' if resourceKey is 'line_item'
        @fetchActivationPlans() if resourceKey is 'campaign'

      onLineItemUpdateAddonQuantity: ->

      removeLineItem: (lineItem) ->
        payloadOptions = { line_item_id: lineItem.id }
        @triggerResource 'line_item', 'remove_line_item', payloadOptions
      onLineItemRemoveLineItem: ->

      removeAddon: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        @triggerResource 'line_item', 'remove_addon_from_line_item', payloadOptions
      onLineItemRemoveAddonFromLineItem: ->

      addAddonLineItem: (lineItem, pricing_model) ->
        payload = { line_item_id: lineItem.id, pricing_model }
        @triggerResource 'line_item', 'add_addon_line_item', payload
      onLineItemAddAddonLineItem: ->

      updateLineItemQuantity: (lineItem, startDate, snapToFit) ->
        payload =
          line_item_id: lineItem.id,
          amount: parseInt(lineItem.quantity)
          start_date: startDate
          snap_to_fit: snapToFit
        @triggerResource 'line_item', 'update_quantity', payload
      onLineItemUpdateQuantity: ->

      updateActivationDate: (lineItem) ->
        [starts_at, ends_at] = @activationDate
        payload = { line_item_id: lineItem.id, starts_at, ends_at }
        @triggerResource 'line_item', 'update_activation_date', payload
      onLineItemUpdateActivationDate: ->

      hiUpdateAddonQuantityFn: (lineItem) ->
        (addon) =>
          payload = { line_item_id: lineItem.id, addon_id: addon.id, amount: parseInt(addon.quantity) }
          @triggerResource 'line_item', 'update_addon_quantity', payload
      onLineItemUpdateAddonQuantity: ->

      promptUpdateLineItemDiscount: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateLineItemDiscount: ->
        @$refs.updateLineItemDiscountTrigger.close()

      promptUpdateAddonDiscount: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        modalOptions = { addon }
        @$refs.updateAddonDiscountTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateAddonDiscount: ->
        @$refs.updateAddonDiscountTrigger.close()
        @creativeEditorModal.show = true

      updateOriginalPriceTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateOriginalPrice: ->
        @$refs.updateOriginalPriceTrigger.close()

      updateOriginalPayoutTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateOriginalPayout: ->
        @$refs.updateOriginalPayoutTrigger.close()

      updateAddonOriginalPriceTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateAddonOriginalPrice: ->
        @$refs.updateAddonOriginalPriceTrigger.close()

      updateAddonOriginalPayoutTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onLineItemUpdateAddonOriginalPayout: ->
        @$refs.updateAddonOriginalPayoutTrigger.close()

      setVariable: (lineItem, name, value) ->
        @triggerResource 'line_item', 'set_variable', { line_item_id: lineItem.id, name, value }
      onLineItemSetVariable: ->

      updateActivationDatesPlan: (lineItem, startDate, endDate, snapToFit=true) ->
        payload = { line_item_id: lineItem.id, start_date: startDate, end_date: endDate, snap_to_fit: snapToFit }
        @triggerResource 'line_item', 'update_activation_dates_plan', payload
      onLineItemUpdateActivationDatesPlan: ->

      updateMaxPalletCount: (lineItem, amount) ->
        payload = { line_item_id: lineItem.id, amount }
        @triggerResource 'line_item', 'update_max_pallet_count', payload
      onLineItemUpdateMaxPalletCount: ->
        @fetchActivationPlans()

      selectShippingPlan: (lineItem, type, snapToFit=true) ->
        payload = { line_item_id: lineItem.id, type, snap_to_fit: snapToFit }
        @triggerResource 'line_item', 'change_shipping_plan_type', payload
      onLineItemChangeShippingPlanType: ->

      addCreditToLineItem: ->
        payloadOptions = { line_item_id: @purchaseOrderItemId }
        modalOptions = { @lineItem }
        @$refs.addCreditToPurchaseOrderLineItemTrigger.fire payloadOptions, modalOptions
      onLineItemAddCreditToLineItem: ->
        @$refs.addCreditToPurchaseOrderLineItemTrigger.close()

      navToPurchaseOrderShowPage: ->
        @$router.push { name: 'PurchaseOrderShowPage', params: { @purchaseOrderId } }

export default VueOptions.vue settings
